<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { filter, loading, records, pagination, initList, onEdit, onPageChange, search, downloadSlaughterMonthlyTotalsReport } from "./visit-history.store";
  import { visitHistoryDtoFields } from "../../utils/TableFields/visit-history-dto.fields";
  import Button from "../../components/Button.svelte";
  import SlaughterYearDropdown from "../../components/Business/SlaughterYearDropdown.svelte";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="macellazione (storico)"
    entityPlural="macellazioni (storico)"
    searchPlaceholder="cerca lotto"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
    <div slot="search" class="level-item weight-label-search-box">
      <div style="min-width: 5rem;">
        <SlaughterYearDropdown name="" required={true} bind:value={$filter.criteria.slaughterYear} on:select={search} />
      </div>
      <p class="control" style="margin-left:1rem;">
        <Button klass="is-warning" on:click={downloadSlaughterMonthlyTotalsReport}>
          <span>Stampa report capi macellati</span>
        </Button>
      </p>
    </div>
  </SearchHeader>

  <Table
    loading={$loading}
    fields={visitHistoryDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={false}
    editEnabled={true}
    deleteEnabled={false}
    on:edit={(e) => onEdit(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
